import React, { useEffect, useState } from 'react';
import { createLabWatchlistItem, deleteLabWatchlistItem, getLabWatchlist, updateLabWatchlistItem } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabTable from '../components/LabTable';

const initialForm = { entity_type: 'serial', entity_key: '', label: '', note: '', severity: 'medium' };

export default function WatchlistPage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(initialForm);

  const load = () => getLabWatchlist().then(setRows);
  useEffect(() => { load(); }, []);

  const handleCreate = async (event) => {
    event.preventDefault();
    await createLabWatchlistItem(form);
    setForm(initialForm);
    load();
  };

  return (
    <div className="lab-page">
      <LabCard title="Watchlist" description="Monitoraggio sperimentale di seriali, stazioni, step, versioni ATE e testspec per non perdere di vista gli elementi critici.">
        <form className="lab-form-grid" onSubmit={handleCreate}>
          <select className="lab-input" value={form.entity_type} onChange={(event) => setForm((current) => ({ ...current, entity_type: event.target.value }))}>
            <option value="serial">serial</option>
            <option value="station">station</option>
            <option value="step">step</option>
            <option value="ate_version">ate_version</option>
            <option value="testspec">testspec</option>
          </select>
          <input className="lab-input" placeholder="Chiave entità" value={form.entity_key} onChange={(event) => setForm((current) => ({ ...current, entity_key: event.target.value }))} />
          <input className="lab-input" placeholder="Etichetta" value={form.label} onChange={(event) => setForm((current) => ({ ...current, label: event.target.value }))} />
          <input className="lab-input" placeholder="Severità" value={form.severity} onChange={(event) => setForm((current) => ({ ...current, severity: event.target.value }))} />
          <input className="lab-input" placeholder="Nota" value={form.note} onChange={(event) => setForm((current) => ({ ...current, note: event.target.value }))} />
          <button type="submit" className="lab-button">Aggiungi elemento</button>
        </form>
        <LabTable
          rows={rows}
          emptyTitle="Nessun elemento in watchlist."
          emptyDescription="Aggiungi un seriale, una stazione o uno step che vuoi tenere sotto controllo nel Lab."
          columns={[
            { key: 'entity_type', label: 'Tipo' },
            { key: 'entity_key', label: 'Chiave' },
            { key: 'label', label: 'Etichetta' },
            { key: 'severity', label: 'Severità' },
            { key: 'is_active', label: 'Attivo', render: (value, row) => <button type="button" className="lab-inline-button" onClick={() => updateLabWatchlistItem(row.id, { is_active: !Number(value) }).then(load)}>{Number(value) ? 'Attivo' : 'Disattivo'}</button> },
            { key: 'id', label: 'Azioni', render: (value) => <button type="button" className="lab-inline-button danger" onClick={() => deleteLabWatchlistItem(value).then(load)}>Elimina</button> },
          ]}
        />
      </LabCard>
    </div>
  );
}
